import * as fromPCtoolsActions from '../../actions/Componentes/panelCTools.actions';


export interface PCtoolsState {
    visible: boolean;
}

const initialSPCTools: PCtoolsState = {
    visible: false
};

export function pCtoolsReducer(state = initialSPCTools, action: fromPCtoolsActions.PCToolsActions): PCtoolsState {
    switch (action.type) {
        case fromPCtoolsActions.VISIBLE_PANELTOOL:
            return {
                ...state,
                visible: true
            };
        case fromPCtoolsActions.HIDDEN_PANELTOOL:
            return {
                ...state,
                visible: false
            };
      default: {
        return state;
      }
    }
}
